import { useState } from "react";
import { NavLink, Routes, Route, useNavigate } from "react-router-dom";
import { LayoutDashboard, Building2, Users, CalendarDays, Newspaper, Settings as Cog, ScrollText, PanelLeft, LogOut } from "lucide-react";
import { AdminAuthProvider, useAdmin } from "./common";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Projects from "./Projects";
import ProjectEdit from "./ProjectEdit";
import Leads from "./Leads";
import Appointments from "./Appointments";
import News from "./News";
import SettingsPage from "./SettingsPage";
import Logs from "./Logs";

const MENU = [
  { to: "/admin", label: "Gösterge", icon: LayoutDashboard, end: true },
  { to: "/admin/projeler", label: "Projeler", icon: Building2 },
  { to: "/admin/crm", label: "CRM / Lead", icon: Users },
  { to: "/admin/randevu", label: "Randevu", icon: CalendarDays },
  { to: "/admin/haberler", label: "Haberler", icon: Newspaper },
  { to: "/admin/ayarlar", label: "Ayarlar", icon: Cog },
  { to: "/admin/kayitlar", label: "İşlem Kayıtları", icon: ScrollText },
];

function Shell() {
  const { user, logout } = useAdmin();
  const [kapali, setKapali] = useState(false);
  const nav = useNavigate();
  return (
    <div className="admin">
      <aside className={`admin-yan ${kapali ? "kapali" : ""}`}>
        <div className="admin-marka">{kapali ? "Ö" : "ÖZALP"}</div>
        {MENU.map((m) => (
          <NavLink key={m.to} to={m.to} end={m.end} className={({ isActive }) => (isActive ? "aktif" : "")} data-testid={`admin-nav-${m.label}`}>
            <m.icon size={17} />{!kapali && m.label}
          </NavLink>
        ))}
        <div className="rol">{!kapali && <>{user?.name}<br />{user?.role}</>}</div>
      </aside>
      <div className="admin-ana">
        <div className="admin-ust">
          <button className="a-btn hayalet kucuk" onClick={() => setKapali((k) => !k)} data-testid="admin-menu-toggle"><PanelLeft size={16} /></button>
          <button className="a-btn hayalet kucuk" onClick={() => { logout(); nav("/admin"); }} data-testid="admin-logout"><LogOut size={16} /> Çıkış</button>
        </div>
        <div className="admin-govde">
          <Routes>
            <Route index element={<Dashboard />} />
            <Route path="projeler" element={<Projects />} />
            <Route path="projeler/:id" element={<ProjectEdit />} />
            <Route path="crm" element={<Leads />} />
            <Route path="randevu" element={<Appointments />} />
            <Route path="haberler" element={<News />} />
            <Route path="ayarlar" element={<SettingsPage />} />
            <Route path="kayitlar" element={<Logs />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function Gate() {
  const { user } = useAdmin();
  if (user === null) return <div className="a-login"><p className="veri" style={{ color: "#fff" }}>Yükleniyor…</p></div>;
  if (!user) return <Login />;
  return <Shell />;
}

export default function AdminApp() {
  return <AdminAuthProvider><Gate /></AdminAuthProvider>;
}
